const atualizarPermissoes = (state, permissoes) => {
    state.permissoes = permissoes;
}
const atualizarPermissoesRegras = (state, permissoesRegras) => {
    state.permissoesRegras = permissoesRegras;
}
const atualizarPermissao = (state, permissao) => {
    state.permissao = permissao;
}

const atualizarRegras = (state, regras) => {
    state.regras = regras;
}

const atualizarRegra = (state, regra) => {
    state.regra = regra;
}

export default {
    atualizarPermissoes,
    atualizarPermissoesRegras,
    atualizarPermissao,
	atualizarRegras,
	atualizarRegra
}